// extracted by mini-css-extract-plugin
export var attachmentContainer = "_lv-0";
export var fileList = "_lv-2";
export var removeFileButton = "_lv-1";